export default function IconSwimming() {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      aria-hidden="true"
    >
      {/* eslint-disable-next-line @stylistic/max-len */}
      <path d="M60.53,40.5a9,9,0,0,0-5.72,1.94,6.12,6.12,0,0,1-7.59,0,9.39,9.39,0,0,0-11.43,0,6.1,6.1,0,0,1-7.58,0,9,9,0,0,0-5.72-1.94,8.94,8.94,0,0,0-5.71,1.94A5.71,5.71,0,0,1,13,43.76a5.68,5.68,0,0,1-3.79-1.32A9,9,0,0,0,3.47,40.5H3v4.74h.47a5.69,5.69,0,0,1,3.8,1.32A8.94,8.94,0,0,0,13,48.5a9,9,0,0,0,5.72-1.94,5.68,5.68,0,0,1,3.79-1.32,5.68,5.68,0,0,1,3.79,1.32,9.39,9.39,0,0,0,11.43,0,6.12,6.12,0,0,1,7.59,0,9.39,9.39,0,0,0,11.43,0,5.69,5.69,0,0,1,3.8-1.32H61V40.5Z" />
      {/* eslint-disable-next-line @stylistic/max-len */}
      <path d="M15.67,38.36a10.12,10.12,0,0,1,5.55-1.52,10.12,10.12,0,0,1,5.55,1.52,7.15,7.15,0,0,0,4.08,1.14,7.15,7.15,0,0,0,4.08-1.14l.5-.28L29.22,27l6-6,9.93,1.63L48,17.79,35.33,15.57a4.62,4.62,0,0,0-3.95,1.16C26.53,21.24,12.58,34.26,8,38.62a6.73,6.73,0,0,0,3.59.88A7.1,7.1,0,0,0,15.67,38.36Z" />
      <circle
        cx="40"
        cy="29.5"
        r="5"
        transform="translate(-4.21 6.79) rotate(-9.22)"
      />
    </svg>
  );
}
